/* eslint-disable no-console */
import { EmmaFactory } from "@axa-asia/hk-emma-js";
import config from "../config";
import {
  FETCH_FIREBASE_EXPERIMENTS_SUCCESS,
  FETCH_OPTIMIZE_EXPERIMENTS_SUCCESS,
} from "../redux/modules/abTest";
import { getExperimentsInStr } from "../utils/abTestUtil";
import { setupExperimentIdsToDataLayer } from "../services/analyticsEvents";

export const initExperiments = () => {
  return async (dispatch, getState) => {
    const getFirebaseExperiments = () => {
        return new Promise((resolve, reject) => {
        const { isApp } = config;
        if (isApp) {
            EmmaFactory.createInstance()
            .then((e) => {
                e.instance
                .getFirebaseRemoteConfig()
                .then((remoteConfig) => {
                    resolve(remoteConfig);
                })
                .catch((error) => {
                    reject(error);
                });
            })
            .catch((error) => {
                reject(error);
            });
        } else {
            resolve({});
        }
        });
    };

    const getOptimizeExperiments = () => {
        return new Promise((resolve, reject) => {
        // TODO - Allen
        resolve({});
        });
    };

    const [firebaseExperiments, optimizeExperiments] = await Promise.all([
        getFirebaseExperiments(),
        getOptimizeExperiments(),
    ]);

    dispatch({
        type: FETCH_FIREBASE_EXPERIMENTS_SUCCESS,
        payload: { firebaseExperiments },
    });
    dispatch({
        type: FETCH_OPTIMIZE_EXPERIMENTS_SUCCESS,
        payload: { optimizeExperiments },
    });

    const experimentIdsStr = getExperimentsInStr(getState());
    setupExperimentIdsToDataLayer(experimentIdsStr);
  }
};
